<section class="custom-filters justify-content-md-end">
  <div class="filter" *ngIf="filterMode === 'restaurant' || filterMode === 'both'">
    <label class="filter-label">Restaurants</label>
    <ion-select
      [value]="restaurantId"
      [disabled]="!isAdmin"
      (ionChange)="onRestaurantChange($event)"
      interface="popover"
      placeholder="Select a restaurant"
      fill="outline"
    >
      <ion-select-option
        *ngFor="let r of restaurants"
        [value]="r.restaurantId"
      >{{ r.name }}</ion-select-option>
    </ion-select>
  </div>

  <div class="filter" *ngIf="filterMode === 'branch' || filterMode === 'both'">
    <label class="filter-label">Branches</label>
    <ion-select
      [value]="branchId"
      (ionChange)="onBranchChange($event)"
      interface="popover"
      placeholder="Select a branch"
      fill="outline"
    >
      <ion-select-option [value]="null">Unassigned</ion-select-option>
      <ion-select-option
        *ngFor="let b of branches"
        [value]="b.restaurantBranchId"
      >{{ b.name }}</ion-select-option>
    </ion-select>
  </div>

  <ng-content></ng-content>
</section>
